import { render, staticRenderFns } from "./EditUinfo.vue?vue&type=template&id=17bc4d11&scoped=true"
import script from "./EditUinfo.vue?vue&type=script&lang=js"
export * from "./EditUinfo.vue?vue&type=script&lang=js"
import style0 from "./EditUinfo.vue?vue&type=style&index=0&id=17bc4d11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc4d11",
  null
  
)

export default component.exports